<template>
<div class="hotConcept" :class="{hotConceptW : type == 'pc'}" v-if="data">
    <div class="hot-left">
    <div class="hot-left-icon"></div>
    <div class="hot-left-text">{{ $t('115') }}</div>
    </div>
    <div class="hot-right">{{ data }}</div>
</div>
</template>

<script>
    export default {
        props: {
            data: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'mobile'
            },
        },
    }
</script>

<style lang="less" scoped>
    .hotConcept {
      position: absolute;
      bottom: 10px;
      left: 10px;
      background-image: linear-gradient(111deg, rgba(255,255,255,0.90) 7%, #FFF0E5 100%);
      border: 0.5px solid #FFFFFF;
      box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.4);
      border-radius: 4px;
      padding: 1px;
      .hot-left {
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 4px 2px 2px;
        background-image: linear-gradient(134deg, #F28B43 7%, #E05220 100%);
        border-radius: 3px;
        margin-right: 4px;
        &-icon {
          width: 13px;
          height: 13px;
          background: url('~@/assets/images/hotWhite.svg') 100% 100%;
          background-size: 100% 100%;
          margin-right: 1px;
        }
        &-text {
          font-size: 12px;
          color: rgba(0,0,0,0.84);
          letter-spacing: 0;
          text-align: justify;
          line-height: 13px;
          font-weight: 500;
          color: #fff;
          font-weight: 600;
        }
      }
      .hot-right {
        float: left;
        max-width: 108px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        color: rgba(0, 0, 0, 0.84);
        letter-spacing: 0;
        text-align: justify;
        line-height: 16px;
        font-weight: 600;
        margin-right: 3px;
      }
    }
    .hotConceptW {
      .hot-right {
        max-width: 163px;
        line-height: 16px;
      }
    }
</style>